"use client";

import { Suspense } from "react";
import { useRouter } from "next/navigation";
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";
import { canUseStudentPortal } from "@/lib/studentPortal";
import { setPortalToken } from "@/lib/portalTokens";
import type { LoginApiResponse } from "@/lib/loginApi";

function ForgotPasswordContent() {
  const router = useRouter();

  const handleSuccess = async (data: LoginApiResponse) => {
    const roles = data.user?.roles || [];
    if (!canUseStudentPortal(roles)) {
      throw new Error("您的账号没有学生端权限（账号需包含 student 角色）");
    }

    setPortalToken("student", data.access_token);
    localStorage.setItem("loginFrom", "student");
    localStorage.setItem("userRole", "student");
    localStorage.removeItem("hasOrgRole");

    if (data.user?.mobile) {
      localStorage.setItem("userMobile", data.user.mobile);
    }

    router.push("/student/home");
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50 justify-center items-center px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">找回密码</h1>
      <p className="text-sm text-gray-600 mb-6">验证手机号后设置新密码</p>
      <ForgotPasswordForm
        accent="indigo"
        portal="student"
        loginHref="/login"
        onSuccess={handleSuccess}
      />
    </div>
  );
}

export default function ForgotPasswordPage() {
  return (
    <Suspense
      fallback={
        <div className="flex flex-col h-screen bg-gray-50 justify-center items-center">
          <p className="text-gray-600">加载中...</p>
        </div>
      }
    >
      <ForgotPasswordContent />
    </Suspense>
  );
}
